<template>
    <el-row type="flex" align="middle" v-if="content && content.message">
        <el-col :span="4">
            <em class="el-icon" :class="contentTypeIcon"></em>
        </el-col>
        <el-col :span="20" class="content-message">
            {{ content.message }}
        </el-col>
    </el-row>
</template>

<script>
export default {
    name: 'StatusContent',
    props: ['content'],
    computed: {
        contentTypeIcon() {
            return this.content && this.content.type
                ? 'el-icon-' + this.content.type
                : '';
        },
    },
};
</script>
<style scoped>
.el-icon {
    font-size: 30px;
}
.el-icon-error {
    color: #d32f2f;
}
.el-icon-warning {
    color: rgb(255, 102, 0);
}
.el-icon-success {
    color: #43a047;
}
.content-message{
    text-align: left;
    font-size:13px;
}
</style>
